import script from "./HomeServiceCarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServiceCarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeServiceCarouselComponent.vue?vue&type=style&index=0&id=224b4196&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224b4196"]])

export default __exports__